import { SideMenu } from "../components/SideMenu/SideMenu.jsx";
import { BackupSettingsPane } from "../features/settings/BackupSettingsPane.jsx";
import { AppearanceSettingsPane } from "../features/settings/AppearanceSettingsPane.jsx";
import { DataSettingsPane } from "../features/settings/DataSettingsPane.jsx";
import { DashboardPage, createDashboardLayout } from "../components/DashboardPage/DashboardPage.jsx";
import { DatabaseSettingsPane } from "../features/settings/DatabaseSettingsPane.jsx";
import { ImportExportSettingsPane } from "../features/settings/ImportExportSettingsPane.jsx";
import { ProfileSettingsPane } from "../features/settings/ProfileSettingsPane.jsx";

export const defaultSettingsSection = "profile";

const settingsPageLayout = createDashboardLayout({
  columns: [
    { size: "fixed", value: "var(--app-side-menu-width)" },
    { size: "fill" }
  ],
  rows: [
    { size: "fill" }
  ],
  areas: [
    ["sections", "content"]
  ]
});

export const settingsSectionItems = [
  {
    value: "profile",
    labelKey: "profile",
    descriptionKey: "navigation.settings.profile"
  },
  {
    value: "appearance",
    labelKey: "appearance",
    descriptionKey: "navigation.settings.appearance"
  },
  {
    value: "import-export",
    labelKey: "importExport",
    descriptionKey: "navigation.settings.importExport"
  },
  {
    value: "backup",
    labelKey: "backup",
    descriptionKey: "navigation.settings.backup"
  },
  {
    value: "data",
    labelKey: "data",
    descriptionKey: "navigation.settings.data"
  },
  {
    value: "database",
    labelKey: "database",
    descriptionKey: "navigation.settings.database"
  }
];

export function SettingsPage({
  onDataImported,
  onScopeChanged,
  activeScope,
  appSettings,
  profileSettings,
  activeSection,
  onSectionChange,
  onThemeChange,
  onLanguageChange,
  onCurrencyChange,
  showAltHints = false,
  t = (key) => key
}) {
  let content = <ProfileSettingsPane onScopeChanged={onScopeChanged} t={t} />;

  if (activeSection === "appearance") {
    content = (
      <AppearanceSettingsPane
        theme={appSettings.theme}
        language={appSettings.language}
        currency={profileSettings.currency}
        onThemeChange={onThemeChange}
        onLanguageChange={onLanguageChange}
        onCurrencyChange={onCurrencyChange}
        t={t}
      />
    );
  }

  if (activeSection === "import-export") {
    content = <ImportExportSettingsPane onDataImported={onDataImported} t={t} />;
  }

  if (activeSection === "backup") {
    content = <BackupSettingsPane activeScope={activeScope} onScopeChanged={onScopeChanged} t={t} />;
  }

  if (activeSection === "database") {
    content = <DatabaseSettingsPane activeScope={activeScope} t={t} />;
  }

  if (activeSection === "data") {
    content = <DataSettingsPane activeScope={activeScope} onScopeChanged={onScopeChanged} t={t} />;
  }

  const sectionItems = settingsSectionItems.map((item) => ({
    ...item,
    label: t(item.labelKey),
    description: t(item.descriptionKey)
  }));

  return (
    <DashboardPage
      layout={settingsPageLayout}
      slots={[
        {
          key: "sections",
          area: "sections",
          content: (
            <SideMenu
              items={sectionItems}
              value={activeSection}
              onChange={onSectionChange}
              showAltHints={showAltHints}
              focusBinding="Alt+S"
            />
          )
        },
        {
          key: `content-${activeSection}`,
          area: "content",
          content
        }
      ]}
    />
  );
}
